import pad from './pad'
import screen from './screen'
import assembly from './assembly'
import { SERVICE_SCHEMAS } from './serviceSchema'

export {
  SERVICE_KEYS,
  SERVICE_ROUTES,
  SERVICE_ANALYTICS_IDS,
  SERVICE_CHROME,
  SERVICE_PORTFOLIO_IMAGES,
  RESET_TITLES,
} from './common'

/** Each service's 1200 x 630 social image (public/), shared by its three locales. */
export const SERVICE_OG_IMAGES = Object.freeze({
  pad: '/og-tampon-baski.jpg',
  screen: '/og-serigrafi.jpg',
  assembly: '/og-montaj-trim.jpg',
})

/**
 * A locale's SEO block with its Service JSON-LD: TR pages keep their own,
 * EN and DE take theirs from serviceSchema.js.
 *
 * @param {'pad' | 'screen' | 'assembly'} key
 * @param {object} record
 * @returns {object}
 */
function withSchemas(key, record) {
  const { schemaId, ...byLang } = SERVICE_SCHEMAS[key]
  return Object.freeze(
    Object.fromEntries(
      Object.entries(record).map(([lang, copy]) => [
        lang,
        copy.seo.schema || !byLang[lang] ? copy : { ...copy, seo: Object.freeze({ ...copy.seo, schemaId, schema: byLang[lang] }) },
      ]),
    ),
  )
}

/** Per-service, per-locale page copy + SEO, keyed 'pad' | 'screen' | 'assembly'. */
export const SERVICES = Object.freeze({
  pad: withSchemas('pad', pad),
  screen: withSchemas('screen', screen),
  assembly: withSchemas('assembly', assembly),
})
